import { render, staticRenderFns } from "./poster-image.vue?vue&type=template&id=76fa5b72&scoped=true&"
import script from "./poster-image.vue?vue&type=script&lang=ts&"
export * from "./poster-image.vue?vue&type=script&lang=ts&"
import style0 from "./poster-image.vue?vue&type=style&index=0&id=76fa5b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fa5b72",
  null
  
)

export default component.exports